import * as go from 'gojs';
import { UnitTypes } from 'unitData/types';
import FeedTemplateComponent from './nodeTemplates/Units/Feed';
import StorageTemplate from './nodeTemplates/Units/Storage';
import StorageWith1OutputTemplate from './nodeTemplates/Units/StorageWith1Output';
import StorageWith2OutputTemplate from './nodeTemplates/Units/StorageWith2Output';
import CrusherCHTemplateComponent from './nodeTemplates/Units/CrusherCH';
import ConeCrusherCSTemplate from './nodeTemplates/Units/CrusherCS';
import GyratoryCrusherCGTemplate from './nodeTemplates/Units/GyratoryCrusherCG';
import JawCrusherCJTemplate from './nodeTemplates/Units/JawCrusherCJ';
import CrusherVSITemplate from './nodeTemplates/Units/CrusherVSI';
import CircularMotionScreenTemplateComponent from './nodeTemplates/Units/CircularMotionScreen';
import LinearMotionScreenTemplate from './nodeTemplates/Units/LinearMotionScreen';
import MultislopeScreenTemplate from './nodeTemplates/Units/MultislopeScreen';
import GrizzlyScreenTemplateComponent from './nodeTemplates/Units/GrizzlyScreen';
import AddTemplate from './nodeTemplates/Units/Add';
import SplitTemplate from './nodeTemplates/Units/Split';
import FeederAndScreenTemplate from './nodeTemplates/Units/FeederAndScreen';
import MobileConeTemplate from './nodeTemplates/MobileUnits/Cone';
import MobileHSITemplate from './nodeTemplates/MobileUnits/HSI';
import MobileJawTemplate from './nodeTemplates/MobileUnits/Jaw';
import MobileJawAndConeTemplate from './nodeTemplates/MobileUnits/JawAndCone';
import MobileVSITemplate from './nodeTemplates/MobileUnits/VSI';
import MobileScreenTemplate from './nodeTemplates/MobileUnits/Screen';
import PanFeederTemplate from './nodeTemplates/Units/PanFeeder';
import PlateFeederTemplate from './nodeTemplates/Units/PlateFeeder';
import GrizzlyFeederTemplate from './nodeTemplates/Units/GrizzlyFeeder';
import FreeFallScreenSFTemplate from './nodeTemplates/Units/FreeFallScreenSF';
import FreeFallScreenSSTemplate from './nodeTemplates/Units/FreeFallScreenSS';
import BananaScreenTemplate from './nodeTemplates/Units/BananaScreen';
import SchenckScreenTemplate from './nodeTemplates/Units/SchenckScreen';
import GenericScreenTemplate from './nodeTemplates/Units/GenericScreen';
import ImpactCrusherCITemplate from './nodeTemplates/Units/ImpactCrusherCI';
import GenericCrusherTemplate from './nodeTemplates/Units/GenericCrusher';
import PrintWindowPanel from './nodeTemplates/Panels/printWindowPanel';
import FreeTextBoxPanel from './nodeTemplates/Panels/freeTextBoxPanel';
import HybridCrusherCRTemplate from './nodeTemplates/Units/HybridCrusherCR';
import KwataniScreenTemplate from './nodeTemplates/Units/KwataniScreen';
import { makePanel } from './nodeTemplates/utils/makePanel';
import { PanelType } from 'store/units/types';
import BreakerTemplate from './nodeTemplates/Units/Breaker';
import HighlightTextbox from './nodeTemplates/Panels/GroupHighlightTextbox';

/**
 * The template map gathers all available templates for how different types of nodes should be displayed.
 * Each template can be selected by specifying the 'category' property in a node
 */
const TemplateMap = new go.Map<string, go.Node>();
TemplateMap.add(UnitTypes.FEED, FeedTemplateComponent);
TemplateMap.add(UnitTypes.STORAGE, StorageTemplate);
TemplateMap.add(UnitTypes.STORAGE_FEEDER, StorageWith1OutputTemplate);
TemplateMap.add(UnitTypes.STORAGE_FEEDER_2_OUTPUTS, StorageWith2OutputTemplate);
TemplateMap.add(UnitTypes.CONE_CRUSHER_CH, CrusherCHTemplateComponent);
TemplateMap.add(UnitTypes.CONE_CRUSHER_CS, ConeCrusherCSTemplate);
TemplateMap.add(UnitTypes.JAW_CRUSHER_CJ, JawCrusherCJTemplate);
TemplateMap.add(UnitTypes.IMPACT_CRUSHER_CV, CrusherVSITemplate);
TemplateMap.add(UnitTypes.HYBRID_CRUSHER_CR, HybridCrusherCRTemplate);
TemplateMap.add(UnitTypes.IMPACT_CRUSHER_CI, ImpactCrusherCITemplate);
TemplateMap.add(UnitTypes.GYRATORY_CRUSHER_CG, GyratoryCrusherCGTemplate);
TemplateMap.add(UnitTypes.GENERIC_CRUSHER, GenericCrusherTemplate);
TemplateMap.add(
  UnitTypes.CONVENTIONAL_SCREEN,
  CircularMotionScreenTemplateComponent,
);
TemplateMap.add(UnitTypes.LINEAR_MOTION_SCREEN, LinearMotionScreenTemplate);
TemplateMap.add(UnitTypes.MULTISLOPE_SCREEN, MultislopeScreenTemplate);
TemplateMap.add(UnitTypes.GRIZZLY_SCREEN, GrizzlyScreenTemplateComponent);
TemplateMap.add(UnitTypes.FREEFALL_SCREEN_SF, FreeFallScreenSFTemplate);
TemplateMap.add(UnitTypes.FREEFALL_SCREEN_SS, FreeFallScreenSSTemplate);
TemplateMap.add(UnitTypes.BANANA_SCREEN, BananaScreenTemplate);
TemplateMap.add(UnitTypes.SCHENCK_SCREEN, SchenckScreenTemplate);
TemplateMap.add(UnitTypes.KWATANI_SCREEN, KwataniScreenTemplate);
TemplateMap.add(UnitTypes.GENERIC_SCREEN, GenericScreenTemplate);
TemplateMap.add(UnitTypes.ADD, AddTemplate);
TemplateMap.add(UnitTypes.SPLIT, SplitTemplate);
TemplateMap.add(UnitTypes.FEEDER_AND_SCREEN, FeederAndScreenTemplate);
TemplateMap.add(UnitTypes.PAN_FEEDER_SP, PanFeederTemplate);
TemplateMap.add(UnitTypes.PLATE_FEEDER_SH, PlateFeederTemplate);
TemplateMap.add(UnitTypes.GRIZZLY_FEEDER_SV, GrizzlyFeederTemplate);
TemplateMap.add(UnitTypes.GRIZZLY_FEEDER_SV_E, GrizzlyFeederTemplate);
TemplateMap.add(UnitTypes.GRIZZLY_FEEDER_SW, GrizzlyFeederTemplate);

TemplateMap.add(UnitTypes.MOBILE_TRACKED_CONE, MobileConeTemplate);
TemplateMap.add(UnitTypes.MOBILE_WHEELED_CONE, MobileConeTemplate);
TemplateMap.add(UnitTypes.MOBILE_TRACKED_JAW, MobileJawTemplate);
TemplateMap.add(UnitTypes.MOBILE_WHEELED_JAW, MobileJawTemplate);
TemplateMap.add(UnitTypes.MOBILE_TRACKED_SCREEN, MobileScreenTemplate);
TemplateMap.add(UnitTypes.MOBILE_WHEELED_SCREEN, MobileScreenTemplate);
TemplateMap.add(UnitTypes.MOBILE_TRACKED_HSI, MobileHSITemplate);
TemplateMap.add(UnitTypes.MOBILE_WHEELED_HSI, MobileHSITemplate);
TemplateMap.add(UnitTypes.MOBILE_VSI, MobileVSITemplate);
TemplateMap.add(UnitTypes.MOBILE_JAW_AND_CONE, MobileJawAndConeTemplate);
TemplateMap.add(UnitTypes.BREAKER, BreakerTemplate);

TemplateMap.add(UnitTypes.PRINT_WINDOW, PrintWindowPanel);
TemplateMap.add(UnitTypes.FREE_TEXT_BOX, FreeTextBoxPanel);
TemplateMap.add(UnitTypes.HIGHLIGHT_TEXT_BOX, HighlightTextbox);

TemplateMap.add(PanelType.INFO_PANEL, makePanel(PanelType.INFO_PANEL));
TemplateMap.add(PanelType.WARNINGS_PANEL, makePanel(PanelType.WARNINGS_PANEL));
TemplateMap.add(
  PanelType.FLOW_PROPERTIES_GRAPH_PANEL,
  makePanel(PanelType.FLOW_PROPERTIES_GRAPH_PANEL),
);
TemplateMap.add(
  PanelType.FLOW_PROPERTIES_SIZE_TABLE_PANEL,
  makePanel(PanelType.FLOW_PROPERTIES_SIZE_TABLE_PANEL),
);
TemplateMap.add(
  PanelType.FLOW_PROPERTIES_PXX_TABLE_PANEL,
  makePanel(PanelType.FLOW_PROPERTIES_PXX_TABLE_PANEL),
);
TemplateMap.add(
  PanelType.PARTICLE_SIZE_DISTRIBUTION_LIST_PANEL,
  makePanel(PanelType.PARTICLE_SIZE_DISTRIBUTION_LIST_PANEL),
);
TemplateMap.add(
  PanelType.PARTICLE_SIZE_DISTRIBUTION_GRAPH_PANEL,
  makePanel(PanelType.PARTICLE_SIZE_DISTRIBUTION_GRAPH_PANEL),
);

export default TemplateMap;
